.container {
  width: 100%;
  position: relative;

  .number-input label {
    font-size: 12px;
    font-weight: 400;
  }
}

.credit-card {
  position: absolute;
  top: 38px;
  right: 10px;
  width: 15px;
}
